<template>
  <div>
    <records
      v-if="!$auth.isAuditor()"
      :paginating="true"
      :filtering="true"
      :exportable="true"
      :bulk="true"
      :actions="true"
    />
    <recording-requests v-else />
  </div>
</template>

<script>
import Records from '@/components/Records'
import RecordingRequests from '@/components/RecordingRequests'

export default {
  components: {
    Records,
    RecordingRequests
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Recordings.vue?3dedd541